var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('footer',[_c('div',{staticClass:"w-full pin-b text-center bg-white p-4",style:(_vm.style.div)},[_c('h1',{style:(_vm.style.h1)},[_vm._v(_vm._s(_vm.phlebsPhoneNumber))]),_c('h4',{style:(_vm.style.h4)},[_vm._v("© I.V. Training Center - All Rights Reserved")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }